/**
 * Determines whether an AlbumMembershipGroup has joined identities.
 * AlbumMembershipGroup can be created from "empty" AlbumMemberships,
 * ie AlbumMemberships without SelectedIdentities.
 *
 * @param {Object} albumMembershipGroup The AlbumMembershipGroup.
 * @returns {boolean}
 */
export const albuMembershipGroupHasJoinedIdentities = albumMembershipGroup => {
  return albumMembershipGroup?.identities?.length > 0;
};
